import { useState } from 'react'
import {
	Collapsible,
	CollapsibleContent,
	CollapsibleTrigger,
} from '@cocoonspace/ui/components/collapsible'
import { useLingui } from '@lingui/react/macro'
import { ChevronDownIcon, PencilIcon } from 'lucide-react'

import {
	SectionTitle,
	SectionTitleBtn,
	SectionWrapper,
} from '~/components/sheet-section-wrapper'
import { useFormSectionCollapsible } from '../use-form-section-collapsible.hook'
import { BookingWindowPreview } from './booking-window-preview'

export const BookingWindowTab = () => {
	const { t } = useLingui()
	const [isOpen, setIsOpen] = useState(false)
	const { onOpenChange, open } = useFormSectionCollapsible(['bookingWindow'])

	return (
		<Collapsible
			open={open}
			onOpenChange={onOpenChange}
		>
			<SectionWrapper>
				<SectionTitle>
					<CollapsibleTrigger className='flex min-w-0 flex-1 items-center gap-2 text-left'>
						{t`Plage de dates`}
					</CollapsibleTrigger>

					<SectionTitleBtn onClick={() => setIsOpen(true)}>
						<PencilIcon />
						{t`Modifier`}
					</SectionTitleBtn>

					<CollapsibleTrigger
						aria-label={t`Plage de dates`}
						className='flex size-4 shrink-0 items-center [&[data-state=open]>svg]:rotate-180'
					>
						<ChevronDownIcon className='size-4 transition-transform' />
					</CollapsibleTrigger>
				</SectionTitle>

				<CollapsibleContent>
					<BookingWindowPreview
						isOpen={isOpen}
						setIsOpen={setIsOpen}
					/>
				</CollapsibleContent>
			</SectionWrapper>
		</Collapsible>
	)
}
